define('model/workflow.process.instance.model',['require','exports','module','underscore','./base.workflow.model','datakit/datakit','./historic.workflow.process.instance.model'],function(require, exports, module) {
  //prettier-ignore
  var _                                    = require('underscore'),
      BaseWorkflowModel                    = require('./base.workflow.model'),
      DataKit                              = require('datakit/datakit'),
      HistoricWorkflowProcessInstanceModel = require('./historic.workflow.process.instance.model');

  var WorkflowProcessInstanceModel = BaseWorkflowModel.extend({
    radioRequests: {
      'models WorkflowProcessInstanceModel': '@constructor',
    },

    urlRoot: '/api/v1/coi-workflow/runtime/process-instances',

    relationshipTypes: {
      hasOne: DataKit.AbstractHasOneRelationshipType.extend({
        initialize: function() {
          DataKit.AbstractHasOneRelationshipType.prototype.initialize.apply(this, arguments);
          this.activeProcessInstanceQueryCollection = new WorkflowProcessInstanceModel.QueryCollection();
          this.historicProcessInstanceQueryCollection = new HistoricWorkflowProcessInstanceModel.QueryCollection();
        },
        configureResource: function() {
          this.activeProcessInstanceQueryCollection.reset();
          this.historicProcessInstanceQueryCollection.reset();
          this.activeProcessInstanceQueryCollection.requestBodyQueryModel.set({
            includeProcessVariables: true,
            // sort: 'endTime',
            order: 'desc',
            size: 1,
            variables: [
              {
                name: this.foreignKey,
                type: 'string',
                value: this.foreignModel.id,
                operation: 'equals',
              },
            ],
          });
          this.historicProcessInstanceQueryCollection.requestBodyQueryModel.set({
            includeProcessVariables: true,
            sort: 'endTime',
            order: 'desc',
            size: 1,
            variables: [
              {
                name: this.foreignKey,
                type: 'string',
                value: this.foreignModel.id,
                operation: 'equals',
              },
            ],
          });
        },
        fetchResource: function() {
          return this.activeProcessInstanceQueryCollection
            .fetch()
            .promise()
            .bind(this)
            .then(function(data) {
              if (this.activeProcessInstanceQueryCollection.isEmpty()) {
                return this.historicProcessInstanceQueryCollection.fetch();
              }
              return data;
            })
              .catch(function(error) {
                console.error('An error occurred while fetching the resource:', error);
              });
        },
        onFetchSuccess: function() {
          if (!this.activeProcessInstanceQueryCollection.isEmpty()) {
            this.resource.set(this.activeProcessInstanceQueryCollection.first().attributes);
          } else if (!this.historicProcessInstanceQueryCollection.isEmpty()) {
            this.resource.set(this.historicProcessInstanceQueryCollection.first().attributes);
          } else {
            this.resource.clear();
          }
        },
      }),
    },

    relationships: {
      workflowStateModel: {
        type: 'extracted',
        extract: function(model) {
          var workflowStateObject = _.find(model.get('variables'), function(variable) {
            return _.result(variable, 'name') == 'workflowState';
          });
          try {
            return JSON.parse(workflowStateObject.value);
          } catch (e) {
            return void 0;
          }
        },
        resourceClass: Backbone.Model,
      },
    },
  });

  WorkflowProcessInstanceModel.QueryCollection = WorkflowProcessInstanceModel.Collection.extend({
    url: '/api/v1/coi-workflow/query/process-instances',

    initialize: function() {
      WorkflowProcessInstanceModel.Collection.prototype.initialize.apply(this, arguments);
      this.requestBodyQueryModel = new Backbone.Model();
    },

    fetch: function(options) {
      return WorkflowProcessInstanceModel.Collection.prototype.fetch.call(
        this,
        _.extend({}, options, {
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(this.requestBodyQueryModel),
        })
      );
    },
  });

  module.exports = WorkflowProcessInstanceModel;
});

